import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=2d1c8f39&scoped=true"
import script from "./section-title.vue?vue&type=script&lang=js"
export * from "./section-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c8f39",
  null
  
)

export default component.exports